<template>
  <div class="business-home-page">
    <hero />

    <companies-logos />

    <benefits />

    <app-screen />

    <stats />

    <reviews i18n-key="b2b" />

    <get-started />
  </div>
</template>

<script>
import Hero from "@/pages/business/components/hero"
import CompaniesLogos from "@/pages/business/components/companies-logos"
import Benefits from "@/pages/business/components/benefits"
import AppScreen from "@/pages/business/components/app-screen"
import GetStarted from "@/pages/business/components/get-started"
import Reviews from "@/pages/business/components/reviews"
import Stats from "@/pages/business/components/blinkist-stats"

export default {
  name: "BusinessHome",
  components: {
    Hero,
    CompaniesLogos,
    Benefits,
    AppScreen,
    GetStarted,
    Reviews,
    Stats
  }
}
</script>
